import { cn } from '@qr-front/ui/utils'
import { qrBackgroundColorAtom } from 'features/generator/pages/QrDesignFormPage/PatternDesignForm'
import { qrDesignAtom } from 'features/generator/pages/QrDesignFormPage/qrDesignState'
import { useAtomValue } from 'jotai'
import { chain } from 'radash'

import {
	isSafariOnNonRetina,
	setSvgAttribute,
	setSvgPositionAttributes,
} from '@/utils'

import { areAllColorsWhite, CONTRAST_BACKGROUND_COLOR } from '../qrImageBuilder'

type TNoFrameQrImageProps = {
	patternMarkup: string
	size: number
	className?: string
}

const setShapeRendering = (svg: string) => {
	const shouldEnableCrispEdges = !isSafariOnNonRetina()

	if (!shouldEnableCrispEdges) {
		return svg
	}

	return setSvgAttribute({
		svg,
		attributeName: 'shape-rendering',
		attributeValue: 'crispEdges',
	})
}

export const NoFrameQrImage = ({
	patternMarkup,
	size,
	className,
}: TNoFrameQrImageProps) => {
	const qrDesign = useAtomValue(qrDesignAtom)!
	const backgroundColor = useAtomValue(qrBackgroundColorAtom)

	return (
		<div
			dangerouslySetInnerHTML={{
				__html: chain(setShapeRendering, (svg) =>
					setSvgPositionAttributes(svg, {
						x: 0,
						y: 0,
						// Compensate for 8px padding
						width: size - 16,
						height: size - 16,
					}),
				)(patternMarkup),
			}}
			className={cn(className, '[>] p-2 [&_*]:transition-none')}
			style={{
				backgroundColor: areAllColorsWhite(qrDesign)
					? CONTRAST_BACKGROUND_COLOR
					: backgroundColor,
			}}
		/>
	)
}
